// @flow

import _ from 'lodash';

import type {
	Error,
	ErrorOptions,
} from './error';

type Enricher = ErrorOptions | (Error) => void;

const enrichers: {
	[string]: {
		[string]: Enricher,
	},
} = {
	'TypeError': {
		'Network request failed': {
			code: 'RGSRUUI-01000',
		},
		'Failed to fetch': {
			code: 'RGSRUUI-01000',
		},
	},
	'HttpError': {
		'Gateway Time-out': {
			code: 'RGSRUUI-01002',
		},
		'Forbidden': {
			code: 'RGSRUUI-01004',
		},
	},
};

export function enrich (error: Error) {
	const enricher: ?Enricher = _.get(enrichers, [
		error.name,
		error.message,
	]);

	if (typeof enricher === 'function') {
		enricher(error);
	} else {
		_.extend(error, enricher);
	}

	return error;
}
